// Static imports from the supplied Qsmart design pack; Metro selects the correct density.
export const icons = {
  "move": require("../../../assets/designs/modern2/icons/move.png"),
  "minus": require("../../../assets/designs/modern2/icons/minus.png"),
  "width-1": require("../../../assets/designs/modern2/icons/width-1.png"),
  "width-2": require("../../../assets/designs/modern2/icons/width-2.png"),
  "width-3": require("../../../assets/designs/modern2/icons/width-3.png"),

  "daily-measurement": require("../../../assets/designs/modern2/icons/daily-measurement.png"),
  "satellite": require("../../../assets/designs/modern2/icons/satellite.png"),
  "overview": require("../../../assets/designs/modern2/icons/overview.png"),
  "position": require("../../../assets/designs/modern2/icons/position.png"),
  "care": require("../../../assets/designs/modern2/icons/care.png"),
  "events": require("../../../assets/designs/modern2/icons/events.png"),
  "activity": require("../../../assets/designs/modern2/icons/activity.png"),
  "device": require("../../../assets/designs/modern2/icons/device.png"),
  "person": require("../../../assets/designs/modern2/icons/person.png"),
  "connection": require("../../../assets/designs/modern2/icons/connection.png"),
  "clock": require("../../../assets/designs/modern2/icons/clock.png"),
  "battery": require("../../../assets/designs/modern2/icons/battery.png"),
  "charging": require("../../../assets/designs/modern2/icons/charging.png"),
  "sim": require("../../../assets/designs/modern2/icons/sim.png"),
  "phone": require("../../../assets/designs/modern2/icons/phone.png"),
  "map": require("../../../assets/designs/modern2/icons/map.png"),
  "route": require("../../../assets/designs/modern2/icons/route.png"),
  "calendar": require("../../../assets/designs/modern2/icons/calendar.png"),
  "play": require("../../../assets/designs/modern2/icons/play.png"),
  "pause": require("../../../assets/designs/modern2/icons/pause.png"),
  "replay": require("../../../assets/designs/modern2/icons/replay.png"),
  "speed": require("../../../assets/designs/modern2/icons/speed.png"),
  "refresh": require("../../../assets/designs/modern2/icons/refresh.png"),
  "gps": require("../../../assets/designs/modern2/icons/gps.png"),
  "mobile": require("../../../assets/designs/modern2/icons/mobile.png"),
  "wifi": require("../../../assets/designs/modern2/icons/wifi.png"),
  "filter": require("../../../assets/designs/modern2/icons/filter.png"),
  "safe-zone": require("../../../assets/designs/modern2/icons/safe-zone.png"),
  "radius": require("../../../assets/designs/modern2/icons/radius.png"),
  "arrival": require("../../../assets/designs/modern2/icons/arrival.png"),
  "departure": require("../../../assets/designs/modern2/icons/departure.png"),
  "toggle": require("../../../assets/designs/modern2/icons/toggle.png"),
  "heart": require("../../../assets/designs/modern2/icons/heart.png"),
  "pressure": require("../../../assets/designs/modern2/icons/pressure.png"),
  "temperature": require("../../../assets/designs/modern2/icons/temperature.png"),
  "oxygen": require("../../../assets/designs/modern2/icons/oxygen.png"),
  "measure": require("../../../assets/designs/modern2/icons/measure.png"),
  "history": require("../../../assets/designs/modern2/icons/history.png"),
  "medicine": require("../../../assets/designs/modern2/icons/medicine.png"),
  "repeat": require("../../../assets/designs/modern2/icons/repeat.png"),
  "call": require("../../../assets/designs/modern2/icons/call.png"),
  "contact": require("../../../assets/designs/modern2/icons/contact.png"),
  "voice": require("../../../assets/designs/modern2/icons/voice.png"),
  "record": require("../../../assets/designs/modern2/icons/record.png"),
  "send": require("../../../assets/designs/modern2/icons/send.png"),
  "callback": require("../../../assets/designs/modern2/icons/callback.png"),
  "sos": require("../../../assets/designs/modern2/icons/sos.png"),
  "fall": require("../../../assets/designs/modern2/icons/fall.png"),
  "wrist": require("../../../assets/designs/modern2/icons/wrist.png"),
  "event": require("../../../assets/designs/modern2/icons/event.png"),
  "warning": require("../../../assets/designs/modern2/icons/warning.png"),
  "check": require("../../../assets/designs/modern2/icons/check.png"),
  "notification": require("../../../assets/designs/modern2/icons/notification.png"),
  "sms": require("../../../assets/designs/modern2/icons/sms.png"),
  "sound": require("../../../assets/designs/modern2/icons/sound.png"),
  "vibration": require("../../../assets/designs/modern2/icons/vibration.png"),
  "silent": require("../../../assets/designs/modern2/icons/silent.png"),
  "steps": require("../../../assets/designs/modern2/icons/steps.png"),
  "distance": require("../../../assets/designs/modern2/icons/distance.png"),
  "energy": require("../../../assets/designs/modern2/icons/energy.png"),
  "active-time": require("../../../assets/designs/modern2/icons/active-time.png"),
  "average": require("../../../assets/designs/modern2/icons/average.png"),
  "chart": require("../../../assets/designs/modern2/icons/chart.png"),
  "trophy": require("../../../assets/designs/modern2/icons/trophy.png"),
  "stride": require("../../../assets/designs/modern2/icons/stride.png"),
  "weight": require("../../../assets/designs/modern2/icons/weight.png"),
  "profile": require("../../../assets/designs/modern2/icons/profile.png"),
  "phonebook": require("../../../assets/designs/modern2/icons/phonebook.png"),
  "priority": require("../../../assets/designs/modern2/icons/priority.png"),
  "find-device": require("../../../assets/designs/modern2/icons/find-device.png"),
  "answer": require("../../../assets/designs/modern2/icons/answer.png"),
  "speaking-clock": require("../../../assets/designs/modern2/icons/speaking-clock.png"),
  "schedule": require("../../../assets/designs/modern2/icons/schedule.png"),
  "restart": require("../../../assets/designs/modern2/icons/restart.png"),
  "power": require("../../../assets/designs/modern2/icons/power.png"),
  "reset": require("../../../assets/designs/modern2/icons/reset.png"),
  "account": require("../../../assets/designs/modern2/icons/account.png"),
  "login": require("../../../assets/designs/modern2/icons/login.png"),
  "logout": require("../../../assets/designs/modern2/icons/logout.png"),
  "password": require("../../../assets/designs/modern2/icons/password.png"),
  "link-device": require("../../../assets/designs/modern2/icons/link-device.png"),
  "qr": require("../../../assets/designs/modern2/icons/qr.png"),
  "share": require("../../../assets/designs/modern2/icons/share.png"),
  "language": require("../../../assets/designs/modern2/icons/language.png"),
  "appearance": require("../../../assets/designs/modern2/icons/appearance.png"),
  "help": require("../../../assets/designs/modern2/icons/help.png"),
  "info": require("../../../assets/designs/modern2/icons/info.png"),
  "customize": require("../../../assets/designs/modern2/icons/customize.png"),
  "reorder": require("../../../assets/designs/modern2/icons/reorder.png"),
  "add": require("../../../assets/designs/modern2/icons/add.png"),
  "edit": require("../../../assets/designs/modern2/icons/edit.png"),
  "save": require("../../../assets/designs/modern2/icons/save.png"),
  "cancel": require("../../../assets/designs/modern2/icons/cancel.png"),
  "delete": require("../../../assets/designs/modern2/icons/delete.png"),
  "confirm": require("../../../assets/designs/modern2/icons/confirm.png"),
  "back": require("../../../assets/designs/modern2/icons/back.png"),
  "chevron": require("../../../assets/designs/modern2/icons/chevron.png"),
  "more": require("../../../assets/designs/modern2/icons/more.png"),
  "close": require("../../../assets/designs/modern2/icons/close.png"),
  "external": require("../../../assets/designs/modern2/icons/external.png"),
  "search": require("../../../assets/designs/modern2/icons/search.png"),
} as const;
